import { cn } from '@/lib/utils'
import { Loader } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'

interface Props {
  className?: string
  text?: string
}

export function CenteredLoader({ className, text }: Props) {
  const translations = useTranslate({
    loading: 'common.loading-ellipsis',
  })

  return (
    <div className={cn('flex justify-center pt-10 text-2xl', className)}>
      <div className="flex items-center justify-center gap-4">
        <Loader.Spinner size={36} thickness={4} />

        <span>{text ?? translations.loading}</span>
      </div>
    </div>
  )
}
